const Terms = () => {
  return (
    <div className="Pages">
      <h1>Terms of Use</h1>
      <p>
        Welcome to ObermanFinancialCoach.com (“Website”), operated by Oberman Financial Coaching (“Company”, “we”, “our”, “us”). By accessing or using our Website, you agree to comply with and be bound by the following Terms of Use. If you do not agree to these Terms, please do not use our Website.
      </p>
      <p>
        1. <b> Acceptance of Terms</b>
        By using our Website, you acknowledge that you have read, understood, and agree to be legally bound by these Terms of Use and our Privacy Policy. If you do not agree to any of these terms, please do not use our Website.
      </p>
      <p>
        2. <b>Modification of Terms</b>
        We reserve the right to modify these Terms of Use at any time. Any changes will be effective immediately upon posting the revised Terms on our Website. Your continued use of the Website following the posting of changes constitutes your acceptance of such changes. We encourage you to review these Terms periodically.
      </p>
      <p>
        3. <b>Use of the Website</b>
        Eligibility: You must be at least 18 years old to use our Website.

        Account Security: If you create an account on our Website, you are responsible for maintaining the security of your account and for all activities that occur under your account.

        Prohibited Activities: You agree not to:

        Violate any applicable laws or regulations.

        Engage in any unauthorized or unlawful use of the Website.

        Attempt to interfere with the Website’s operation or security.
      </p>
      <p>
        4. <b>Intellectual Property</b>
        All content on the Website, including but not limited to text, graphics, logos, images, and software, is the property of Oberman Financial Coaching or its licensors and is protected by copyright, trademark, and other intellectual property laws. Unauthorized use of any content on the Website is strictly prohibited.
      </p>
      <p>
        5. <b>Disclaimers and Limitation of Liability</b>
        No Warranty: The Website is provided on an “as is” and “as available” basis. We make no warranties or representations about the accuracy or completeness of the Website’s content or the content of any sites linked to the Website.

        Limitation of Liability: To the fullest extent permitted by law, Oberman Financial Coaching will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the Website.
      </p>
      <p>
        6. <b>Governing Law</b>
        These Terms of Use shall be governed by and construed in accordance with the laws of the State of Minnesota, without regard to its conflict of law principles.
      </p>
    </div>
  );
};

export default Terms;
